import ParentalConsent from "./ParentalConsent";
export default ParentalConsent